const INDEX_ITEMS = [
  { title: '影视剧场', desc: '热门电影电视剧高清合集', icon: 'ri-movie-2-line', count: '1.2万部' },
  { title: '综艺娱乐', desc: '最新综艺节目每日更新', icon: 'ri-emotion-laugh-line', count: '8600集' },
  { title: '动漫专区', desc: '日漫国漫经典一站收录', icon: 'ri-ghost-line', count: '6300部' },
  { title: '短视频创作', desc: '原创达人精彩短视频', icon: 'ri-vidicon-line', count: '15万条' },
  { title: '纪录片频道', desc: '自然人文历史精品纪录', icon: 'ri-earth-line', count: '4200部' },
  { title: '体育赛事', desc: '热门赛事回放与集锦', icon: 'ri-basketball-line', count: '9800场' },
  { title: '音乐 MV', desc: '华语欧美日韩音乐视频', icon: 'ri-music-2-line', count: '3.6万首' },
];

const CARD_ITEMS = [
  {
    title: '观影指南：本月不容错过的十部好片',
    desc: '编辑团队根据播放数据和用户口碑，精选本月最值得观看的十部影片，帮你快速找到心仪内容。',
    image: 'https://readdy.ai/api/search-image?query=Movie%20night%20atmosphere%20with%20warm%20coral%20and%20amber%20lighting%2C%20film%20clapper%20and%20popcorn%20silhouette%2C%20cozy%20home%20theater%20vibe%2C%20soft%20glow%2C%20cinematic%20mood%2C%20no%20text%2C%20abstract%20entertainment%20art&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '指南',
    date: '2026-07-28',
  },
  {
    title: '新用户必读：榴莲视频使用技巧大全',
    desc: '从搜索技巧到画质设置，从离线缓存到投屏方法，这篇指南让你快速成为观影高手。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tech%20tutorial%20theme%20with%20warm%20lighting%2C%20clean%20minimal%20setup%2C%20soft%20coral%20accents%2C%20digital%20learning%20concept%2C%20elegant%20workspace%20atmosphere%2C%20no%20text%2C%20abstract%20design&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '教程',
    date: '2026-07-26',
  },
  {
    title: '暑期档爆款预测：哪些内容即将刷屏',
    desc: '基于历史数据和平台趋势，预测今年暑期档最有可能成为爆款的视频内容类型与话题方向。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20vibes%20abstract%20with%20warm%20golden%20hour%20lighting%2C%20trending%20up%20arrow%20concept%2C%20vibrant%20coral%20and%20amber%20gradient%2C%20hot%20topic%20theme%2C%20no%20text%2C%20modern%20minimal%20design&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '预测',
    date: '2026-07-25',
  },
  {
    title: '经典重温：那些年我们追过的神作',
    desc: '回顾近十年来平台上播放量最高的经典影视作品，每一部都承载着无数观众的回忆与感动。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20cinema%20theme%20with%20warm%20vintage%20tones%2C%20retro%20film%20projector%20abstract%2C%20soft%20coral%20and%20gold%20lighting%2C%20classic%20movie%20memories%20vibe%2C%20no%20text%2C%20elegant%20composition&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '经典',
    date: '2026-07-23',
  },
  {
    title: '弹幕文化观察：用户最爱讨论的片段',
    desc: '分析平台上弹幕最密集的十大场景，看看大家都在哪些情节中产生共鸣与热烈讨论。',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20conversation%20theme%20abstract%2C%20flowing%20comment%20bubbles%20with%20warm%20coral%20highlights%2C%20community%20engagement%20concept%2C%20modern%20digital%20art%2C%20no%20text%2C%20soft%20glow%20effects&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '观察',
    date: '2026-07-22',
  },
  {
    title: 'APP 4.0 版本亮点功能全面解析',
    desc: '全新改版的移动端 APP 带来更智能的推荐系统、更流畅的播放体验，一文了解所有新变化。',
    image: 'https://readdy.ai/api/search-image?query=Mobile%20app%20update%20concept%20with%20warm%20coral%20gradient%2C%20modern%20smartphone%20silhouette%2C%20digital%20innovation%20theme%2C%20clean%20minimal%20design%2C%20soft%20glow%20effects%2C%20no%20text&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '更新',
    date: '2026-07-20',
  },
];

export default function IndexCardsSection() {
  return (
    <>
      {/* #index */}
      <section id="index" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-grid-line text-sm"></i>
              内容索引
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              分类频道导航
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
              七大内容板块，快速找到你感兴趣的视频类型
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
            {INDEX_ITEMS.map((item, idx) => (
              <div
                key={idx}
                className="group p-4 rounded-xl bg-background-100 border border-background-200/60 text-center hover:-translate-y-0.5 hover:border-accent-300 transition-all duration-200 cursor-pointer"
              >
                <div className="w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-accent-200 transition-colors duration-200">
                  <i className={`${item.icon} text-accent-500 text-lg`}></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 mb-1 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                <span className="text-xs text-accent-600 font-medium">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #cards */}
      <section id="cards" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-article-line text-sm"></i>
              最新资讯
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              图文资讯卡片
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
              观影指南、使用技巧与平台动态一网打尽
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {CARD_ITEMS.map((item, idx) => (
              <div
                key={idx}
                className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="aspect-[3/2] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="font-medium text-foreground-950 text-sm mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}